import React, { Component, useReducer, useEffect, useState, useRef } from "react";
import axios from 'axios';
import { TweenLite } from "gsap";

import { PJContext } from "./components/pj-context"
import CONSTS from "./components/pj-constants";

import {PJOrderStart} from "./components/pj-01-purchase-start"
import {PJAddonSelector} from "./components/pj-01-addon-selector"
import {PJOrderReview} from "./components/pj-02-order-review";
import {PJExistingCustomerCheck} from "./components/pj-03-existing-customer-check";
import {PJAccountHolderCheck} from "./components/pj-04-account-holder-check";
import {PJAccountLogin} from "./components/pj-05-account-login";
import {PJPersonalDetails} from "./components/pj-05b-personal-details";
import {PJAccountValidation} from "./components/pj-06-account-validation";
import {PJOrderConfirmation} from "./components/pj-07-order-confirmation";
import {PJPaymentFrame} from "./components/pj-08-payment-frame";
import {PJOrderSummaryBar} from "./components/pj-01-order-summary-bar";
import {PJBreadCrumbs} from "./components/pj-breadcrumbs";




//DF: use wp.element
//Actions types



let initialState = {
    selectedAddons: {},
    standaloneSelected: {},
    disabledAddons: {}, //throughout the purchase journey user might select items that automatically disable other ones (i.e. because they will be already included in a selected package).
    totalPrice: 0,
    monthlyTotal: 0,
    orderTotal:0,
    seasonTotal:0,
    currentStep: CONSTS.STEP_1_START,
    existingCustomer: false,
    deposit:0,
    installationFee:0,
    seasonTickets:false
};


function purchaseAction(state, action) {
    let newState;
    newState = {...state};
    /*
        Make selections
     */
    switch (action.type) {
        case CONSTS.SELECT_ADDON:
            //When in a group clikcing on addon is already selected.
            if (newState.selectedAddons[action.args.group.id] === action.args.addon) {
                //If this addon has any standalone addons included, re-enable them if they were disabled.
                Object.keys(action.args.addon.included).forEach(function (addonID) {
                    if (newState.disabledAddons[addonID] === true) {
                        delete newState.disabledAddons[addonID];
                    }
                });


                delete newState.selectedAddons[action.args.group.id]; //Deselect addon for this group
            } else { //When in a group clicking on addon that is not selected.
                //If this addon has any standalone addons included, de-select and disable them from selecting

                newState.disabledAddons = {};
                Object.keys(action.args.addon.included).forEach(function (addonID) {
                    newState.disabledAddons[addonID] = true; //
                    if (typeof newState.standaloneSelected[addonID] !== "undefined") { //deselect
                        delete newState.standaloneSelected[addonID];
                    }
                });

                newState.selectedAddons[action.args.group.id] = action.args.addon; //Select it. It also overwrites any previously selected addon.
            }
            break;

        case CONSTS.SELECT_STANDALONE_ADDON:
            if (newState.standaloneSelected[action.args.addon.id] === action.args.addon) {
                delete newState.standaloneSelected[action.args.addon.id];
            } else {
                newState.standaloneSelected[action.args.addon.id] = action.args.addon;
            }
            break;
        case CONSTS.SEASON_TICKETS_TOGGLE:
            newState.seasonTickets = !newState.seasonTickets;
            break;
        case CONSTS.SET_STEP:
            newState.currentStep = action.args.step;

            if (action.args.existingCustomer) {
                newState.existingCustomer = true;
            } else if (typeof action.args.existingCustomer !== 'undefined') {
                newState.existingCustomer = false;
            }
            break;
        case CONSTS.DATA_LOADING:
            //This state change does not need recaulcualtion. Bailing early;
            return {...state, dataLoading: action.loading};

        case CONSTS.LOAD_DATA:
            if (action.data.type === 'product') {
                newState.totalPrice = action.data.price;
                newState.monthlyTotal = action.data.price;
                newState.orderTotal = action.data.price;
            } else {
                newState.totalPrice = action.data.bundlePrice;
                newState.monthlyTotal = action.data.bundlePrice;
                newState.orderTotal = action.data.bundlePrice;
            }
            newState.deposit = action.data.deposit;
            newState.installationFee = action.data.installationFee;
            break;
        case CONSTS.CLOSE_JOURNEY:
            jQuery('body').trigger('close-purchase-journey');
            break;
        case CONSTS.COMPLETE_JOURNEY:
            jQuery('body').trigger('complete-purchase-journey', [action.data.purchase_complete_message]);
            break;

    }

    /*
        Calculate total addons Price
     */
    // newState.totalPrice = 0;
    let addonsPrice = 0;
    let seasonPrice = 0;
    Object.keys(newState.selectedAddons).map((addonKey, i) => {
        addonsPrice += Number.parseFloat(newState.selectedAddons[addonKey].price);

        if (newState.selectedAddons[addonKey].seasonPrice !== undefined && newState.selectedAddons[addonKey].seasonPrice > 0) {
            seasonPrice += Number.parseFloat(newState.selectedAddons[addonKey].seasonPrice);
        }
    });
    Object.keys(newState.standaloneSelected).map((addonKey, i) => {
        addonsPrice += Number.parseFloat(newState.standaloneSelected[addonKey].price);
    });
    newState.monthlyTotal = newState.totalPrice +  addonsPrice;
    newState.seasonTotal = seasonPrice;

    if (newState.existingCustomer) {
        newState.orderTotal = 0;
    } else {
        newState.orderTotal = newState.deposit + newState.installationFee;
    }

    return newState;
}


function PurchaseFunnel(props) {

    const [state, dispatch] = useReducer(purchaseAction, initialState);
    const [data, setData] = useState(false);
    const [userData, setUserData] = useState({});

    /*
        Load Purchase funnel data
    */
    useEffect(() => {
        console.log('Component Loaded.');
        dispatch({type:CONSTS.DATA_LOADING, loading:true});

        axios.post('/getFunnelData', {
            id:props.id,
            type:props.type
        })
            .then(function (response) {
                // console.log(response);
                switch (response.data.status) {
                    case 'OK':
                        if (response.data.data !== false) {
                            setData( response.data.data);// General data storage. DF: Might put it into the main state. But will need refactor all coda that uses it.
                            dispatch({type:CONSTS.LOAD_DATA, data:response.data.data}); // Update journey calculated values
                        } else {
                            dispatch({type:CONSTS.CLOSE_JOURNEY}); // Close journey if no data received. DF: dump error
                        }
                        break;
                    case 'ERROR':
                        setData(false);
                        break;
                }
            })
            .catch(function (error) {
                setData(false);
            })
            .then(() => { //ALWAYS
                dispatch({type:CONSTS.DATA_LOADING, loading:false});
            })
        ;
    }, []);

    useEffect(() => {
        console.log('Data Loaded.', data);
        if (data !== false) {
            jQuery('body').trigger('purchase-funnel-loaded');
        }
    }, [data]);

    useEffect(() => {
        window.addEventListener("message", onOrderComplete, false);
        return function () {
            window.removeEventListener("message", onOrderComplete, false);
        }
    });

    function onOrderComplete(event) {
        console.log(event);
        if (event.origin === Rev.origin && event.data.orderSuccess === true) {
            dispatch({ type: CONSTS.COMPLETE_JOURNEY, data:data});
            window.removeEventListener("message", onOrderComplete, false);
        }
    }

    function isCurrentStep(step) {
        // return 'current-step';
        return ((state.currentStep === step) ? 'current-step' : '');
    }


    //Animations for switching between addon selector and checkout
    const $selectAddonsStepRef = useRef(null);

    /**
     * When user moves to checkout
     */
    function animateToCheckout() {
        jQuery($selectAddonsStepRef.current).fadeOut(function () {
            //When animation done change state
            if ((state.selectedAddons !== undefined && //If addons selected
                typeof state.selectedAddons === 'object' &&
                Object.keys(state.selectedAddons).length !== 0)) {
                //Showorder review
                dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_2_ORDER_REVIEW} });
            } else {
                //If no addons selected. Go straigh to signup journey
                dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_3_EXISTING_CUSTOMER} });
            }
        })
    }

    /**
     * When user comes back to checkout (<- Go back)
     */
    function animateFromCheckout() {
        jQuery($selectAddonsStepRef.current).fadeIn(function () {
            //When animation done change state
            dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_1_START} });
        })
    }


    return  (
        <PJContext.Provider value={{ state, dispatch, data, isCurrentStep, animateToCheckout, animateFromCheckout }}>
        <div className="container purchase-funnel">

            {data !== false &&
                <>
                    <div className="row ">
                        <div className="col-sm-10 offset-sm-1 col-xs-12 offset-xs-0">
                            <PJBreadCrumbs/>
                        </div>
                    </div>

                    {/****************************
                     STEP 1
                     ****************************/}
                    <div className={"select-addons journey-step " + isCurrentStep(CONSTS.STEP_1_START)} ref={$selectAddonsStepRef}>
                        <div className="row heading">
                            <PJOrderStart />
                        </div>
                        {(data.addons.groups.length > 0|| data.addons.standalone.length > 0) &&
                            <div className={'row'}>
                                <PJAddonSelector />
                            </div>
                        }

                        <PJOrderSummaryBar />
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-sm-10 offset-sm-1">

                                {/****************************
                                 STEP 2
                                 ****************************/}

                                <PJOrderReview current={isCurrentStep(CONSTS.STEP_2_ORDER_REVIEW)}/>

                                {/****************************
                                 STEP 3
                                 ****************************/}
                                <PJExistingCustomerCheck current={isCurrentStep(CONSTS.STEP_3_EXISTING_CUSTOMER)}/>

                                {/****************************
                                 STEP 4
                                 ****************************/}
                                <PJAccountHolderCheck current={isCurrentStep(CONSTS.STEP_4_ACCOUNT)}/>

                                {/****************************
                                 STEP 5 A
                                 ****************************/}
                                <PJAccountLogin current={isCurrentStep(CONSTS.STEP_5_ACCOUNT_CREDENTIALS)}/>

                                {/****************************
                                 STEP 5 B
                                 ****************************/}
                                <PJPersonalDetails current={isCurrentStep(CONSTS.STEP_5b_PERSONAL_DETAILS)}/>


                                {/****************************
                                 STEP 6
                                 ****************************/}
                                <PJAccountValidation current={isCurrentStep(CONSTS.STEP_6_ACCOUNT_DETAILS)}/>


                                {/****************************
                                 STEP 7
                                 ****************************/}
                                <PJOrderConfirmation  current={isCurrentStep(CONSTS.STEP_7_ORDER_CONFIRMATION)}/>


                                {/****************************
                                 STEP 8
                                 ****************************/}
                                <PJPaymentFrame current={isCurrentStep(CONSTS.STEP_8_PAYMENT_FRAME)}/>

                            </div>
                        </div>
                    </div>
                </>
            }
        </div>

        </PJContext.Provider>
    );
}


export { PurchaseFunnel };


